import config from "../botconfig"
import { useTranslation } from "react-i18next"
import { LanguageContext } from '../contexts/language'
import { useContext } from "react"
import { ThemeContext } from '../contexts/theme';
export function AppFooter() {
    const { t } = useTranslation()
    const [ language ] = useContext(LanguageContext)
    const [ Theme, setTheme] = useContext(ThemeContext)
    return (
        <div className="footer_root">
            <div className="footer_container">
                <div className="footer_content">
                    <div style={{ display: "grid" }}>
                        <span className="font-600">{t('Ссылки')}</span>
                        <a href={language === "ru" ? 'https://docs.wetbot.space/terms-of-use' : 'https://docs.wetbot.space/v/eng/terms-of-use'} target="_blank" rel="noopener noreferrer" className="footer_link">{t('Условия использования')}</a>
                        <a href={language === "ru" ? 'https://docs.wetbot.space/privacy-policy' : 'https://docs.wetbot.space/v/eng/privacy-policy'} target="_blank" rel="noopener noreferrer" className="footer_link">{t('Политика конфиденциальности')}</a>
                        <a href={config.supportServerInvite} target="_blank" rel="noopener noreferrer" className="footer_link">{t('Сервер поддержки')}</a>
                        <a href={language === "ru" ? 'https://docs.wetbot.space' : 'https://docs.wetbot.space/v/eng'} target="_blank" rel="noopener noreferrer" className="footer_link">{t('Документация')}</a>    
                    </div>
                    <div style={{ display: "grid" }}>
                        <span className="font-600">{t('Мониторинги')}</span>
                        <a href="https://boticord.top/bot/801814636168740914" target="_blank" rel="noopener noreferrer" className="footer_link">{t('WETBOT на boticord.top')}</a>
                        <a href="https://bots.server-discord.com/801814636168740914" target="_blank" rel="noopener noreferrer" className="footer_link">{t('WETBOT на SD.C')}</a>
                        <a href="https://top.gg/bot/801814636168740914" target="_blank" rel="noopener noreferrer" className="footer_link">{t('WETBOT на top.gg')}</a>    
                    </div>
                    
                </div>
                <div>
                <iframe src={`https://discord.com/widget?id=543682846175264788&theme=${Theme}`} width="300" height="300" allowtransparency="true" frameBorder="0" sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"></iframe> 
                </div>
            </div>
        </div>
    )
}